import { NEDProductDetailsComponent } from './ned-product-details.component';
export default NEDProductDetailsComponent;
